module.exports = __webpack_public_path__ + "static/img/technology.a802bd1a.jpeg";